import isEmpty from 'lodash/isEmpty';
import { createSelector } from 'reselect';
import { TourState } from './types';
import { TourStep, FtueTour } from 'types';

export const getTourStepByName = (state: TourState, props: any): TourStep | any =>
  state.allTours[props.name].steps.find(s => s.name === props.step);

export function getCurrentStep({ allTours, queuedTours, currentStep }: TourState): TourStep | any {
  if (!queuedTours.length) return null;

  const currentTour = allTours[queuedTours[0]];

  if (isEmpty(queuedTours) || !currentTour) return {};

  return currentTour.steps[currentStep];
}

const getNameFor =
  property =>
  (_, props): string =>
    props[property];

export const getViewedTour = (state: TourState, props: any): FtueTour =>
  state.toursViewed[props.name];

export const isUnviewedCallout = createSelector(
  [getViewedTour, getNameFor('step')],
  (viewedTour, step) => {
    if (!viewedTour) return true;

    const foundStep = viewedTour.steps.find(s => s.name === step);
    return !foundStep || !foundStep.viewed;
  }
);

export const hideCallout = createSelector(
  [state => state, getNameFor('name')],
  ({ auth, ftue }, name) => !auth.isAuthenticated || !ftue.allTours[name]
);

export const isCurrentStep = createSelector(
  [getCurrentStep, getTourStepByName],
  (currentStep, step) => currentStep === step
);

export const showFtueCallout = createSelector(
  [isCurrentStep, isUnviewedCallout],
  (isCurrentStep, isUnviewedCallout) => isCurrentStep && isUnviewedCallout
);
